import { Injectable, Injector } from '@angular/core';
import { ParameterAsync } from 'projects/common/src/app/classes';
import { NotificationHandlerService, CacheService } from 'projects/common/src/app/services';
import { CommunicationSecurityService } from 'src/app/services/communication';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserDataService } from '../user-data/user-data.service';
import { Observable } from 'rxjs';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication';
import { ISession } from 'projects/common/src/app/interfaces/authentication';

/**
 * Servicio para mantener
 */
@Injectable({
  providedIn: 'root',
})
export class AppCollectionService extends ParameterAsync<IRawApplication[]> {
  private securityBaseUrl: string;

  constructor(
    protected httpService: CommunicationSecurityService,
    protected notificationService: NotificationHandlerService,
    private userdata: UserDataService,
    private injector: Injector,
  ) {
    super(httpService, notificationService);
    this.name = 'app-collection';
    this.securityBaseUrl = environment.securityBasePath;
    this.urlEndpoint = `${this.securityBaseUrl}/menu/usermenu`;
  }

  public start(): Promise<IRawApplication[]> {
    return new Promise((resolve) => {
      const argument = this.getArgument();
      this.httpService.get(this.urlEndpoint || this.name, argument).subscribe(
        (response: IRawApplication[]) => {
          this.set(response);
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          // TODO Error a configuracion
          this.error(`Error en solicitud.`, error.name, error.message, error.status);
          // TODO Error a configuracion
          this.notificationService.error(`[${this.name}] Error en solicitud.`);

          const session = this.injector.get(CacheService).local('session') as ISession;
          if (session && session.permissions) {
            const moduleFound = session.permissions.find((mod) => mod.object === 'MODULO' && mod.permission === 'ACTIVAR');
            const menuFound = session.permissions.find((mod) => mod.object === 'MENU' && mod.permission === 'ACTIVAR');
            if (!moduleFound) {
              this.injector.get(AuthenticationService).cleanSessionCode('m006');
            } else if (!menuFound) {
              this.injector.get(AuthenticationService).cleanSessionCode('m008', 'Menu');
            }
          } else {
            this.set(null);
            resolve(null);
          }
        },
      );
    });
  }

  public getArgument() {
    const userId = this.userdata.userId();
    if (userId) {
      return { userId };
    }
    return null;
  }

  public startWhen(source: Observable<any>): void {
    this.subscription = source.pipe(filter((data) => !!data)).subscribe(() => {
      this.alreadyStarted = true;
      this.start();
    });
  }
}
